// extracted by mini-css-extract-plugin
export default {"root":"mkXuF4","SeparateBasicMenuButtonNSkin":"in7AfU","separateBasicMenuButtonNSkin":"in7AfU","linkElement":"hWEbj2","label":"_YMhZp","wrapper":"iKysqE","borderWrapper":"_16LsKt"};